module.exports = __webpack_public_path__ + "static/media/after-school-snacks.1225ef47.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/after-school-snacks.mp4
// module id = 834
// module chunks = 0